import { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import { BEEScorecardService } from '../../../Component/Api/BEEScorecard/BEEScorecard';
import { ConfirmationDialog } from '../../../Component/Common/Components/ConfirmationDialog';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { VAClientCertificateModal } from './CertificatesModal';
import { VAClientScorecardTableMapper } from './ScorecardsTableColumn';
import { VerificationAgencyClientApplicationService } from '../../../Component/Api/VerificationAgency/VerificationAgencyClientApplication/VerificationAgencyClientApplicationService';
import { ApplicationLinkedScorecardsSearchRequest, VerificationAgencyClientApplication } from '../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication';
import { useHistory } from 'react-router-dom';
import { verificationAgency } from '../../../Component/Common/Constants/routes';


export const VAClientScorecards = () => {

  const [verificationCompany, setVerificationCompany] = useRecoilState(VerificationCompanyAtom);
  const [scorecardData, setScorecardData] = useState<VerificationAgencyClientApplication.LinkedScorecardsDto[]>([]);
  const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
  const [filteredItemsCount, setFilteredItemsCount] = useState<number>(1);
  const [totalItemsCount, setTotalItemsCount] = useState<number>(1);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);

  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
  const confirmDeleteMessage = "Are you sure you want to delete this scorecard?";
  const [selectedScorecardId, setSelectedScorecardId] = useState<string>("");
  const [showViewCertificatesModal, setShowViewCertificatesModal] = useState<boolean>(false);
  const history = useHistory();

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  }

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  }

  const columnSortingChanged = (sortOption: ColumnSortOption) => {
    setColumnSortOptions([sortOption]);
    setPageNumber(1);
  }

  const searchRequest: ApplicationLinkedScorecardsSearchRequest = {
    pageNumber: pageNumber,
    pageSize: entriesPerPage.defaultValue!,
    columnSortOptions: columnSortOptions,
    vaClientId: verificationCompany.vaClientId
};

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const scorecardResult = await VerificationAgencyClientApplicationService.SearchApplicationLinkedScorecards(searchRequest);
      setScorecardData(scorecardResult.data.results);
      setFilteredItemsCount(scorecardResult.data.filteredItemsCount);
      setTotalItemsCount(scorecardResult.data.totalItemsCount);

    } catch (error) {
      setScorecardData([]);
      setFilteredItemsCount(1);
      setTotalItemsCount(1);
    } finally {
      setIsLoading(false);
    }
  }

  const showDeleteConfirmation = (id: string) => {
    setSelectedScorecardId(id);
    setShowConfirmationDialog(true);
  }

  const handleCloseConfirmation = () => {
    setShowConfirmationDialog(false);
    setSelectedScorecardId("");
  }

  const handleViewCertificates = (id: string) => {
    setShowViewCertificatesModal(true);
    setSelectedScorecardId(id);
  }

  const handleCloseViewCertificatesModal = () => {
    setShowViewCertificatesModal(false);
  }

  const handleDelete = async () => {
    try {
      await BEEScorecardService.deleteScorecard(selectedScorecardId);
      toast.success("Successfully deleted scorecard");
      fetchData();
    } catch (error) {
      console.log(error)
    } finally {
      handleCloseConfirmation();
    }
  }
  const handleRouteToApplication = (companyId: number, applicationId: number) => {
    setVerificationCompany({ ...verificationCompany, vaClientId: companyId, applicationId: applicationId});
    history.push(`/${verificationAgency.company}/${verificationAgency.applications}/serviceRequired`);
}

  useEffect(() => {
    fetchData();
  }, [entriesPerPage, pageNumber, columnSortOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const tableData = VAClientScorecardTableMapper(scorecardData, verificationCompany.vaClientId, handleViewCertificates, showDeleteConfirmation, handleRouteToApplication); //Map the API data into the table

  return (
    <>
      <MDBox>
        <MDTypography variant='h4' fontWeight='bold'>
          Scorecards
        </MDTypography>
      </MDBox>
      <DataTable
        key={totalItemsCount}
        table={tableData!}
        entriesPerPage={entriesPerPage}
        pageNumber={pageNumber}
        filteredItemsCount={filteredItemsCount}
        totalItemsCount={totalItemsCount}
        entriesPerPageChanged={entriesPerPageChanged}
        pageNumberChanged={pageNumberChanged}
        isLoading={isLoading}
        columnSortingChanged={columnSortingChanged}
        manualSorting={true}
      ></DataTable>

      <ConfirmationDialog
        showDialog={showConfirmationDialog}
        handleAccept={handleDelete}
        handleCancel={handleCloseConfirmation}
        heading={"Confirm Delete"}
        message={confirmDeleteMessage}
      />
      {showViewCertificatesModal && <VAClientCertificateModal showModal={showViewCertificatesModal} handleCancel={handleCloseViewCertificatesModal} scorecardId={selectedScorecardId} />}
    </>
  )
}

